<div class="tabs flex">
	<div
		class="tab mr-4 cursor-pointer"
		*ngFor="let tabs of tabs"
		(click)="selectionContent(tabs?.value || '1')"
	>
		<span
			[ngClass]="{
				'border-b-2 border-primary-color pb-1': view === tabs?.value
			}"
		>
			{{ tabs?.label }}
		</span>
	</div>
</div>
